import React from "react";
import {Card, CardBody, CardTitle} from "reactstrap";
import { ITitleDescription } from "../../Interfaces/base";

export interface CardBoxProps extends ITitleDescription {
	icon: string;
}

const CardBox = ({icon, title, description}: CardBoxProps) => {
  const normalizedContent = Array.isArray(description) ? description.join(", ") : description;

  return(<Card className="card-box">
    <CardBody>
      <img src={icon} alt ='benefits-icon' className='box-image'/>
      <div>
        <CardTitle className='mb-3'>{title}</CardTitle>
        <div className="card-text" dangerouslySetInnerHTML={{ __html: normalizedContent }} />
      </div>
    </CardBody>
  </Card>)
}

export default CardBox;